import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import Back from "../../components/goBack";
import Entry from "./taxAnswerEntry";
import TaxDue from "./taxDue";

class TaxCalAnswer extends Component {
  state = {
    info: ""
  };

  componentDidMount() {
    this.getAnswer(JSON.parse(localStorage.MobileBntinCalcAnswer));
  }

  getAnswer = data => {
    setTimeout(() => {
      // console.log(this.state);
    }, 3000);
    this.setState({ info: data });
  };

  goBack = () => {
    this.props.history.push("/calc");
  };

  render() {
    let nairaSign = <div>({"\u20A6"})</div>;
    return (
      <div style={styles.container}>
        <Back clickHandler={this.goBack} />
        <div style={styles.groupView}>
          <p style={styles.groupHeading}>Monthly PIT Summary</p>
          <Entry
            heading={"Gross Income"}
            currency={nairaSign}
            value={this.state.info.gross_income_month}
            style={styles.entry}
          />
          <Entry
            heading={"Deductions"}
            currency={nairaSign}
            value={this.state.info.deductions_month}
            style={styles.entry}
          />
          <Entry
            heading={"Net Income"}
            currency={nairaSign}
            value={this.state.info.net_income_month}
            style={styles.entry}
          />
          <Entry
            heading={"Consolidated Relief"}
            currency={nairaSign}
            value={this.state.info.consolidated_relief_month}
            style={styles.entry}
          />
          <Entry
            heading={"Taxable Income"}
            currency={nairaSign}
            value={this.state.info.taxable_income_month}
            style={styles.entry}
          />
          <Entry
            heading={"Effective Tax Rate(%)"}
            value={this.state.info.effective_tax_rate_month}
            style={styles.entry}
          />
          <TaxDue
            heading={"Tax Due"}
            currency={nairaSign}
            value={this.state.info.tax_due_month}
            style={styles.entry}
          />
        </div>

        <div style={styles.groupView}>
          <p style={styles.groupHeading}>Annual PIT Summary</p>
          <Entry
            heading={"Gross Income"}
            currency={nairaSign}
            value={this.state.info.gross_income}
            style={styles.entry}
          />
          <Entry
            heading={"Deductions"}
            currency={nairaSign}
            value={this.state.info.deductions}
            style={styles.entry}
          />
          <Entry
            heading={"Net Income"}
            currency={nairaSign}
            value={this.state.info.net_income}
            style={styles.entry}
          />
          <Entry
            heading={"Consolidated Relief"}
            currency={nairaSign}
            value={this.state.info.consolidated_relief}
            style={styles.entry}
          />
          <Entry
            heading={"Taxable Income"}
            currency={nairaSign}
            value={this.state.info.taxable_income}
            style={styles.entry}
          />
          <Entry
            heading={"Effective Tax Rate(%)"}
            value={this.state.info.effective_tax_rate}
            style={styles.entry}
          />
          <TaxDue
            heading={"Tax Due"}
            currency={nairaSign}
            value={this.state.info.tax_due}
            style={styles.entry}
            color={"red"}
          />
        </div>
      </div>
    );
  }
}

const styles = {
  container: {
    display: "flex",
    flexDirection: "column",

    paddingRight: 10
  },
  entry: {
    width: "100%"
  },
  taxDue: {
    fontWeight: "bold"
  },
  groupView: {
    display: "flex",
    flexDirection: "column",
    borderStyle: "solid",
    borderWidth: 1,
    borderRadius: 2,
    borderColor: "#ddd",
    borderBottomWidth: 0,
    shadowColor: "#000",
    shadowOffset: { width: 0, height: 2 },
    shadowOpacity: 0.8,
    shadowRadius: 2,
    elevation: 2,
    marginLeft: 5,
    marginBottom: 10,
    marginRight: 5,
    marginTop: 10,
    width: "100%",
    paddingBottom: 3
    // paddingRight: 10
  },
  groupHeading: {
    display: "flex",
    alignSelf: "center",
    fontSize: 25,
    padding: 3,
    color: "blue"
  }
};

export default withRouter(TaxCalAnswer);
